import firebase from "@/firebase";
import util from "@/util";
export default {
  namespaced: true,
  state: {
    tested: 7.5,
    goal: 7.5,
    oz: 0,
    vol: 0,
    raiseType: "washing soda",
    raiseTypes: ["washing soda", "soda ash", "borax"],
    lowerType: {
      value: "muriatic acid 15",
      name: "Muriatic Acid - 15.7% (10°) Baumé",
      multiplier: 2.0,
    },
    lowerTypes: [
      {
        value: "muriatic acid 15",
        name: "Muriatic Acid - 15.7% (10°) Baumé",
        multiplier: 2.0,
      },
      {
        value: "muriatic acid 28",
        name: "Muriatic Acid - 28.3% (18°) Baumé",
        multiplier: 1.11111,
      },
      {
        value: "muriatic acid 31",
        name: "Muriatic Acid - 31.45% (20°) Baumé",
        multiplier: 1.0,
      },
      {
        value: "muriatic acid 34",
        name: "Muriatic Acid - 34.6% (22°) Baumé",
        multiplier: 0.909091,
      },
      {
        value: "muriatic acid 14",
        name: "Muriatic Acid - 14.5%",
        multiplier: 2.16897,
      },
      {
        value: "muriatic acid 29",
        name: "Muriatic Acid - 29%",
        multiplier: 1.08448,
      },
      {
        value: "dry acid",
        name: "dry acid",
      },
    ],
  },
  getters: {
    getPH(state) {
      return state;
    },
  },
  mutations: {
    calcPH(state, data) {
      const gallons = util.getGallons(
        data.settings.volume,
        data.settings.unitType
      );
      let delta = (state.goal - state.tested) * gallons;
      let temp = (state.tested + state.goal) / 2;
      let adj =
        ((192.1626 +
          -60.1221 * temp +
          6.0752 * temp * temp +
          -0.1943 * temp * temp * temp) *
          (data.ta + 13.91)) /
        114.6;
      let extra =
        (-5.476259 +
          2.414292 * temp +
          -0.355882 * temp * temp +
          0.01755 * temp * temp * temp) *
        data.borate;

      extra *= delta;
      delta *= adj;

      state.oz = state.vol = 0;

      if (state.tested < state.goal) {
        if (state.raiseType === "borax") {
          state.oz = util.getWeight(
            delta / 110.05 + extra / 110.05,
            data.settings.unitType
          );
          state.vol = util.getVolume(
            (delta / 110.05 + extra / 110.05) * 0.9586,
            data.settings.unitType
          );
        } else {
          state.oz = util.getWeight(
            delta / 218.68 + extra / 218.68,
            data.settings.unitType
          );
          state.vol = util.getVolume(
            (delta / 218.68 + extra / 218.68) * 0.8715,
            data.settings.unitType
          );
        }
      } else if (state.tested > state.goal) {
        if (state.lowerType.name === "dry acid") {
          state.oz = util.getWeight(
            delta / -178.66 + extra / -178.66,
            data.settings.unitType
          );
          state.vol = util.getVolume(
            (delta / -178.66 + extra / -178.66) * 0.6657,
            data.settings.unitType
          );
        } else {
          state.vol = util.getVolume(
            (delta / -240.15) * state.lowerType.multiplier +
              (extra / -240.15) * state.lowerType.multiplier,
            data.settings.unitType
          );
        }
      }
    },
    setPH(state, ph) {
      if (!ph) {
        return;
      }
      state.tested = Number(ph.tested) || Number(state.tested);
      state.goal = Number(ph.goal) || Number(state.goal);
      state.oz = ph.oz || state.oz;
      state.vol = ph.vol || state.vol;
      state.raiseType = ph.raiseType || state.raiseType;
      state.lowerType = ph.lowerType || state.lowerType;
    },
  },
  actions: {
    async initPH(state) {
      if (!firebase.auth.currentUser) return;
      const doc = await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("ph")
        .get();
      const ph = doc.data();
      state.commit("setPH", ph);
    },
    async savePH(state, data) {
      if (!firebase.auth.currentUser) return;
      await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("ph")
        .set({
          tested: data.tested,
          goal: data.goal,
          oz: data.oz,
          vol: data.vol,
          raiseType: data.raiseType,
          lowerType: data.lowerType,
        });
      state.commit("setPH", data);
    },
  },
};
